const messages = {
  errorMessage: {
    mandatory: "Please complete this field.",
    noMatch: "Your passwords do not match, please try again.",
    invalidCurrentPassword: "Incorrect password, Please try again.",
    matchHistoryPassword: "Your password must not be the same as the last 10 passwords used.",
    requiredUsername: "Please enter your user ID",
    requiredUserEmail: "Please enter your email address",
    requiredPassword: "Please enter your password",
    alphaNumAllowed: "Special characters are not allowed.",
    someSpecialChar: "Only these special character (!@#$%^&*) are allowed",
    validEmailAllowed: "Invalid email format.",
    requiredCurrentPwd: "Please enter your current password",
    requiredPrefName: "Missing preferred name",
    minLengthText: "Should be minimum 3 character",
    maxLengthText: "Should be maximum 75 character",
    invalidIdNumber: "Invalid ID Number entered",
    invalidClientNumber: "Invalid Client Number entered",
    requiredIdNumber: "Please enter your ID Number",
    requiredDOB: "Enter a valid date format: DD-MM-YYYY.",
    dobValidation: "DD/MM/YYYY Format allowed",
    idTypeRequired: "Please select ID Type",
    requiredPolicyNumber:
      "Please enter a valid policy/certificate number. Your policy/certificate number can be found in your renewal certificates",
    invalidOTP: "Invalid OTP, please try again.",
    otpExpired: "Your OTP has expired. Resend the OTP and try again.",
    otpMaxAttempt: "You've reached the maximum number of OTP attempts. Close this screen and sign in again to continue.",
    otpDuplicateMobile: "Duplicate mobileNo found, please update your mobileNo.",
    numbericOnly: "Only numeric allowed",
    onlyAlphabetSpace: "Name should include only letters [A-Z],space.",
    registerNumber: "Enter a valid mobile number.",
    empty: "Cannot be empty",
    countryRequired: "Please select country",
    minAndNumeric: "Please enter minimum 8 digit numeric mobile number.",
    idNumbermaxLengthText: "Should be maximum 30 character",
    clientNumbermaxLengthText: "Should be maximum 8 character",
    noMatchPasswordRequirement: "Your password does not meet the requirements below.",
    accessDenied: "Invalid sign in credentials",
    existingEmailAddress: "Unable to process your request. Please try again.",
  },
  successMessage: {
    changeSuccess: "Password successfully changed.",
  },
  infoMessage: {
    verificationLink:
      "Click on the verification link sent to example@greateasternlife.com to Receive your OTP.",
  },
  modalMessage: {},
};
const countries = [
  {
    name: "Singapore",
    dial_code: "+65",
    iso_code: "sg",
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    iso_code: "my",
  },
  {
    name: "Afghanistan",

    dial_code: "+93",

    iso_code: "AF",
  },
  {
    name: "Aland Islands",

    dial_code: "+358",

    iso_code: "AX",
  },
  {
    name: "Albania",

    dial_code: "+355",

    iso_code: "AL",
  },
  {
    name: "Algeria",

    dial_code: "+213",

    iso_code: "DZ",
  },
  {
    name: "AmericanSamoa",

    dial_code: "+1 684",

    iso_code: "AS",
  },
  {
    name: "Andorra",

    dial_code: "+376",

    iso_code: "AD",
  },
  {
    name: "Angola",

    dial_code: "+244",

    iso_code: "AO",
  },
  {
    name: "Anguilla",

    dial_code: "+1 264",

    iso_code: "AI",
  },
  {
    name: "Antarctica",

    dial_code: "+672",

    iso_code: "AQ",
  },
  {
    name: "Antigua and Barbuda",

    dial_code: "+1268",

    iso_code: "AG",
  },
  {
    name: "Argentina",

    dial_code: "+54",

    iso_code: "AR",
  },
  {
    name: "Armenia",

    dial_code: "+374",

    iso_code: "AM",
  },
  {
    name: "Aruba",

    dial_code: "+297",

    iso_code: "AW",
  },
  {
    name: "Australia",

    dial_code: "+61",

    iso_code: "AU",
  },
  {
    name: "Austria",

    dial_code: "+43",

    iso_code: "AT",
  },
  {
    name: "Azerbaijan",

    dial_code: "+994",

    iso_code: "AZ",
  },
  {
    name: "Bahamas",

    dial_code: "+1 242",

    iso_code: "BS",
  },
  {
    name: "Bahrain",

    dial_code: "+973",

    iso_code: "BH",
  },
  {
    name: "Bangladesh",

    dial_code: "+880",

    iso_code: "BD",
  },
  {
    name: "Barbados",

    dial_code: "+1 246",

    iso_code: "BB",
  },
  {
    name: "Belarus",

    dial_code: "+375",

    iso_code: "BY",
  },
  {
    name: "Belgium",

    dial_code: "+32",

    iso_code: "BE",
  },
  {
    name: "Belize",

    dial_code: "+501",

    iso_code: "BZ",
  },
  {
    name: "Benin",

    dial_code: "+229",

    iso_code: "BJ",
  },
  {
    name: "Bermuda",

    dial_code: "+1 441",

    iso_code: "BM",
  },
  {
    name: "Bhutan",

    dial_code: "+975",

    iso_code: "BT",
  },
  {
    name: "Bolivia, Plurinational State of",

    dial_code: "+591",

    iso_code: "BO",
  },
  {
    name: "Bosnia and Herzegovina",

    dial_code: "+387",

    iso_code: "BA",
  },
  {
    name: "Botswana",

    dial_code: "+267",

    iso_code: "BW",
  },
  {
    name: "Brazil",

    dial_code: "+55",

    iso_code: "BR",
  },
  {
    name: "British Indian Ocean Territory",

    dial_code: "+246",

    iso_code: "IO",
  },
  {
    name: "Brunei Darussalam",

    dial_code: "+673",

    iso_code: "BN",
  },
  {
    name: "Bulgaria",

    dial_code: "+359",

    iso_code: "BG",
  },
  {
    name: "Burkina Faso",

    dial_code: "+226",

    iso_code: "BF",
  },
  {
    name: "Burundi",

    dial_code: "+257",

    iso_code: "BI",
  },
  {
    name: "Cambodia",

    dial_code: "+855",

    iso_code: "KH",
  },
  {
    name: "Cameroon",

    dial_code: "+237",

    iso_code: "CM",
  },
  {
    name: "Canada",

    dial_code: "+1",

    iso_code: "CA",
  },
  {
    name: "Cape Verde",

    dial_code: "+238",

    iso_code: "CV",
  },
  {
    name: "Cayman Islands",

    dial_code: "+ 345",

    iso_code: "KY",
  },
  {
    name: "Central African Republic",

    dial_code: "+236",

    iso_code: "CF",
  },
  {
    name: "Chad",

    dial_code: "+235",

    iso_code: "TD",
  },
  {
    name: "Chile",

    dial_code: "+56",

    iso_code: "CL",
  },
  {
    name: "China",

    dial_code: "+86",

    iso_code: "CN",
  },
  {
    name: "Christmas Island",

    dial_code: "+61",

    iso_code: "CX",
  },
  {
    name: "Cocos (Keeling) Islands",

    dial_code: "+61",

    iso_code: "CC",
  },
  {
    name: "Colombia",

    dial_code: "+57",

    iso_code: "CO",
  },
  {
    name: "Comoros",

    dial_code: "+269",

    iso_code: "KM",
  },
  {
    name: "Congo",

    dial_code: "+242",

    iso_code: "CG",
  },
  {
    name: "Congo, The Democratic Republic of the Congo",

    dial_code: "+243",

    iso_code: "CD",
  },
  {
    name: "Cook Islands",

    dial_code: "+682",

    iso_code: "CK",
  },
  {
    name: "Costa Rica",

    dial_code: "+506",

    iso_code: "CR",
  },
  {
    name: "Cote d'Ivoire",

    dial_code: "+225",

    iso_code: "CI",
  },
  {
    name: "Croatia",

    dial_code: "+385",

    iso_code: "HR",
  },
  {
    name: "Cuba",

    dial_code: "+53",

    iso_code: "CU",
  },
  {
    name: "Cyprus",

    dial_code: "+357",

    iso_code: "CY",
  },
  {
    name: "Czech Republic",

    dial_code: "+420",

    iso_code: "CZ",
  },
  {
    name: "Denmark",

    dial_code: "+45",

    iso_code: "DK",
  },
  {
    name: "Djibouti",

    dial_code: "+253",

    iso_code: "DJ",
  },
  {
    name: "Dominica",

    dial_code: "+1 767",

    iso_code: "DM",
  },
  {
    name: "Dominican Republic",

    dial_code: "+1 849",

    iso_code: "DO",
  },
  {
    name: "Ecuador",

    dial_code: "+593",

    iso_code: "EC",
  },
  {
    name: "Egypt",

    dial_code: "+20",

    iso_code: "EG",
  },
  {
    name: "El Salvador",

    dial_code: "+503",

    iso_code: "SV",
  },
  {
    name: "Equatorial Guinea",

    dial_code: "+240",

    iso_code: "GQ",
  },
  {
    name: "Eritrea",

    dial_code: "+291",

    iso_code: "ER",
  },
  {
    name: "Estonia",

    dial_code: "+372",

    iso_code: "EE",
  },
  {
    name: "Ethiopia",

    dial_code: "+251",

    iso_code: "ET",
  },
  {
    name: "Falkland Islands (Malvinas)",

    dial_code: "+500",

    iso_code: "FK",
  },
  {
    name: "Faroe Islands",

    dial_code: "+298",

    iso_code: "FO",
  },
  {
    name: "Fiji",

    dial_code: "+679",

    iso_code: "FJ",
  },
  {
    name: "Finland",

    dial_code: "+358",

    iso_code: "FI",
  },
  {
    name: "France",

    dial_code: "+33",

    iso_code: "FR",
  },
  {
    name: "French Guiana",

    dial_code: "+594",

    iso_code: "GF",
  },
  {
    name: "French Polynesia",

    dial_code: "+689",

    iso_code: "PF",
  },
  {
    name: "Gabon",

    dial_code: "+241",

    iso_code: "GA",
  },
  {
    name: "Gambia",

    dial_code: "+220",

    iso_code: "GM",
  },
  {
    name: "Georgia",

    dial_code: "+995",

    iso_code: "GE",
  },
  {
    name: "Germany",

    dial_code: "+49",

    iso_code: "DE",
  },
  {
    name: "Ghana",

    dial_code: "+233",

    iso_code: "GH",
  },
  {
    name: "Gibraltar",

    dial_code: "+350",

    iso_code: "GI",
  },
  {
    name: "Greece",

    dial_code: "+30",

    iso_code: "GR",
  },
  {
    name: "Greenland",

    dial_code: "+299",

    iso_code: "GL",
  },
  {
    name: "Grenada",

    dial_code: "+1 473",

    iso_code: "GD",
  },
  {
    name: "Guadeloupe",

    dial_code: "+590",

    iso_code: "GP",
  },
  {
    name: "Guam",

    dial_code: "+1 671",

    iso_code: "GU",
  },
  {
    name: "Guatemala",

    dial_code: "+502",

    iso_code: "GT",
  },
  {
    name: "Guernsey",

    dial_code: "+44",

    iso_code: "GG",
  },
  {
    name: "Guinea",

    dial_code: "+224",

    iso_code: "GN",
  },
  {
    name: "Guinea-Bissau",

    dial_code: "+245",

    iso_code: "GW",
  },
  {
    name: "Guyana",

    dial_code: "+595",

    iso_code: "GY",
  },
  {
    name: "Haiti",

    dial_code: "+509",

    iso_code: "HT",
  },
  {
    name: "Holy See (Vatican City State)",

    dial_code: "+379",

    iso_code: "VA",
  },
  {
    name: "Honduras",

    dial_code: "+504",

    iso_code: "HN",
  },
  {
    name: "Hong Kong",

    dial_code: "+852",

    iso_code: "HK",
  },
  {
    name: "Hungary",

    dial_code: "+36",

    iso_code: "HU",
  },
  {
    name: "Iceland",

    dial_code: "+354",

    iso_code: "IS",
  },
  {
    name: "India",

    dial_code: "+91",

    iso_code: "IN",
  },
  {
    name: "Indonesia",

    dial_code: "+62",

    iso_code: "ID",
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",

    dial_code: "+98",

    iso_code: "IR",
  },
  {
    name: "Iraq",

    dial_code: "+964",

    iso_code: "IQ",
  },
  {
    name: "Ireland",

    dial_code: "+353",

    iso_code: "IE",
  },
  {
    name: "Isle of Man",

    dial_code: "+44",

    iso_code: "IM",
  },
  {
    name: "Israel",

    dial_code: "+972",

    iso_code: "IL",
  },
  {
    name: "Italy",

    dial_code: "+39",

    iso_code: "IT",
  },
  {
    name: "Jamaica",

    dial_code: "+1 876",

    iso_code: "JM",
  },
  {
    name: "Japan",

    dial_code: "+81",

    iso_code: "JP",
  },
  {
    name: "Jersey",

    dial_code: "+44",

    iso_code: "JE",
  },
  {
    name: "Jordan",

    dial_code: "+962",

    iso_code: "JO",
  },
  {
    name: "Kazakhstan",

    dial_code: "+7 7",

    iso_code: "KZ",
  },
  {
    name: "Kenya",

    dial_code: "+254",

    iso_code: "KE",
  },
  {
    name: "Kiribati",

    dial_code: "+686",

    iso_code: "KI",
  },
  {
    name: "Korea, Democratic People's Republic of Korea",

    dial_code: "+850",

    iso_code: "KP",
  },
  {
    name: "Korea, Republic of South Korea",

    dial_code: "+82",

    iso_code: "KR",
  },
  {
    name: "Kuwait",

    dial_code: "+965",

    iso_code: "KW",
  },
  {
    name: "Kyrgyzstan",

    dial_code: "+996",

    iso_code: "KG",
  },
  {
    name: "Laos",

    dial_code: "+856",

    iso_code: "LA",
  },
  {
    name: "Latvia",

    dial_code: "+371",

    iso_code: "LV",
  },
  {
    name: "Lebanon",

    dial_code: "+961",

    iso_code: "LB",
  },
  {
    name: "Lesotho",

    dial_code: "+266",

    iso_code: "LS",
  },
  {
    name: "Liberia",

    dial_code: "+231",

    iso_code: "LR",
  },
  {
    name: "Libyan Arab Jamahiriya",

    dial_code: "+218",

    iso_code: "LY",
  },
  {
    name: "Liechtenstein",

    dial_code: "+423",

    iso_code: "LI",
  },
  {
    name: "Lithuania",

    dial_code: "+370",

    iso_code: "LT",
  },
  {
    name: "Luxembourg",

    dial_code: "+352",

    iso_code: "LU",
  },
  {
    name: "Macao",

    dial_code: "+853",

    iso_code: "MO",
  },
  {
    name: "Macedonia",

    dial_code: "+389",

    iso_code: "MK",
  },
  {
    name: "Madagascar",

    dial_code: "+261",

    iso_code: "MG",
  },
  {
    name: "Malawi",

    dial_code: "+265",

    iso_code: "MW",
  },
  {
    name: "Maldives",

    dial_code: "+960",

    iso_code: "MV",
  },
  {
    name: "Mali",

    dial_code: "+223",

    iso_code: "ML",
  },
  {
    name: "Malta",

    dial_code: "+356",

    iso_code: "MT",
  },
  {
    name: "Marshall Islands",

    dial_code: "+692",

    iso_code: "MH",
  },
  {
    name: "Martinique",

    dial_code: "+596",

    iso_code: "MQ",
  },
  {
    name: "Mauritania",

    dial_code: "+222",

    iso_code: "MR",
  },
  {
    name: "Mauritius",

    dial_code: "+230",

    iso_code: "MU",
  },
  {
    name: "Mayotte",

    dial_code: "+262",

    iso_code: "YT",
  },
  {
    name: "Mexico",

    dial_code: "+52",

    iso_code: "MX",
  },
  {
    name: "Micronesia, Federated States of Micronesia",

    dial_code: "+691",

    iso_code: "FM",
  },
  {
    name: "Moldova",

    dial_code: "+373",

    iso_code: "MD",
  },
  {
    name: "Monaco",

    dial_code: "+377",

    iso_code: "MC",
  },
  {
    name: "Mongolia",

    dial_code: "+976",

    iso_code: "MN",
  },
  {
    name: "Montenegro",

    dial_code: "+382",

    iso_code: "ME",
  },
  {
    name: "Montserrat",

    dial_code: "+1664",

    iso_code: "MS",
  },
  {
    name: "Morocco",

    dial_code: "+212",

    iso_code: "MA",
  },
  {
    name: "Mozambique",

    dial_code: "+258",

    iso_code: "MZ",
  },
  {
    name: "Myanmar",

    dial_code: "+95",

    iso_code: "MM",
  },
  {
    name: "Namibia",

    dial_code: "+264",

    iso_code: "NA",
  },
  {
    name: "Nauru",

    dial_code: "+674",

    iso_code: "NR",
  },
  {
    name: "Nepal",

    dial_code: "+977",

    iso_code: "NP",
  },
  {
    name: "Netherlands",

    dial_code: "+31",

    iso_code: "NL",
  },
  {
    name: "New Caledonia",

    dial_code: "+687",

    iso_code: "NC",
  },
  {
    name: "New Zealand",

    dial_code: "+64",

    iso_code: "NZ",
  },
  {
    name: "Nicaragua",

    dial_code: "+505",

    iso_code: "NI",
  },
  {
    name: "Niger",

    dial_code: "+227",

    iso_code: "NE",
  },
  {
    name: "Nigeria",

    dial_code: "+234",

    iso_code: "NG",
  },
  {
    name: "Niue",

    dial_code: "+683",

    iso_code: "NU",
  },
  {
    name: "Norfolk Island",

    dial_code: "+672",

    iso_code: "NF",
  },
  {
    name: "Northern Mariana Islands",

    dial_code: "+1 670",

    iso_code: "MP",
  },
  {
    name: "Norway",

    dial_code: "+47",

    iso_code: "NO",
  },
  {
    name: "Oman",

    dial_code: "+968",

    iso_code: "OM",
  },
  {
    name: "Pakistan",

    dial_code: "+92",

    iso_code: "PK",
  },
  {
    name: "Palau",

    dial_code: "+680",

    iso_code: "PW",
  },
  {
    name: "Palestinian Territory, Occupied",

    dial_code: "+970",

    iso_code: "PS",
  },
  {
    name: "Panama",

    dial_code: "+507",

    iso_code: "PA",
  },
  {
    name: "Papua New Guinea",

    dial_code: "+675",

    iso_code: "PG",
  },
  {
    name: "Paraguay",

    dial_code: "+595",

    iso_code: "PY",
  },
  {
    name: "Peru",

    dial_code: "+51",

    iso_code: "PE",
  },
  {
    name: "Philippines",

    dial_code: "+63",

    iso_code: "PH",
  },
  {
    name: "Pitcairn",

    dial_code: "+872",

    iso_code: "PN",
  },
  {
    name: "Poland",

    dial_code: "+48",

    iso_code: "PL",
  },
  {
    name: "Portugal",

    dial_code: "+351",

    iso_code: "PT",
  },
  {
    name: "Puerto Rico",

    dial_code: "+1 939",

    iso_code: "PR",
  },
  {
    name: "Qatar",

    dial_code: "+974",

    iso_code: "QA",
  },
  {
    name: "Romania",

    dial_code: "+40",

    iso_code: "RO",
  },
  {
    name: "Russia",

    dial_code: "+7",

    iso_code: "RU",
  },
  {
    name: "Rwanda",

    dial_code: "+250",

    iso_code: "RW",
  },
  {
    name: "Reunion",

    dial_code: "+262",

    iso_code: "RE",
  },
  {
    name: "Saint Barthelemy",

    dial_code: "+590",

    iso_code: "BL",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",

    dial_code: "+290",

    iso_code: "SH",
  },
  {
    name: "Saint Kitts and Nevis",

    dial_code: "+1 869",

    iso_code: "KN",
  },
  {
    name: "Saint Lucia",

    dial_code: "+1 758",

    iso_code: "LC",
  },
  {
    name: "Saint Martin",

    dial_code: "+590",

    iso_code: "MF",
  },
  {
    name: "Saint Pierre and Miquelon",

    dial_code: "+508",

    iso_code: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",

    dial_code: "+1 784",

    iso_code: "VC",
  },
  {
    name: "Samoa",

    dial_code: "+685",

    iso_code: "WS",
  },
  {
    name: "San Marino",

    dial_code: "+378",

    iso_code: "SM",
  },
  {
    name: "Sao Tome and Principe",

    dial_code: "+239",

    iso_code: "ST",
  },
  {
    name: "Saudi Arabia",

    dial_code: "+966",

    iso_code: "SA",
  },
  {
    name: "Senegal",

    dial_code: "+221",

    iso_code: "SN",
  },
  {
    name: "Serbia",

    dial_code: "+381",

    iso_code: "RS",
  },
  {
    name: "Seychelles",

    dial_code: "+248",

    iso_code: "SC",
  },
  {
    name: "Sierra Leone",

    dial_code: "+232",

    iso_code: "SL",
  },
  {
    name: "Slovakia",

    dial_code: "+421",

    iso_code: "SK",
  },
  {
    name: "Slovenia",

    dial_code: "+386",

    iso_code: "SI",
  },
  {
    name: "Solomon Islands",

    dial_code: "+677",

    iso_code: "SB",
  },
  {
    name: "Somalia",

    dial_code: "+252",

    iso_code: "SO",
  },
  {
    name: "South Africa",

    dial_code: "+27",

    iso_code: "ZA",
  },
  {
    name: "South Georgia and the South Sandwich Islands",

    dial_code: "+500",

    iso_code: "GS",
  },
  {
    name: "Spain",

    dial_code: "+34",

    iso_code: "ES",
  },
  {
    name: "Sri Lanka",

    dial_code: "+94",

    iso_code: "LK",
  },
  {
    name: "Sudan",

    dial_code: "+249",

    iso_code: "SD",
  },
  {
    name: "Suriname",

    dial_code: "+597",

    iso_code: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",

    dial_code: "+47",

    iso_code: "SJ",
  },
  {
    name: "Swaziland",

    dial_code: "+268",

    iso_code: "SZ",
  },
  {
    name: "Sweden",

    dial_code: "+46",

    iso_code: "SE",
  },
  {
    name: "Switzerland",

    dial_code: "+41",

    iso_code: "CH",
  },
  {
    name: "Syrian Arab Republic",

    dial_code: "+963",

    iso_code: "SY",
  },
  {
    name: "Taiwan",

    dial_code: "+886",

    iso_code: "TW",
  },
  {
    name: "Tajikistan",

    dial_code: "+992",

    iso_code: "TJ",
  },
  {
    name: "Tanzania, United Republic of Tanzania",

    dial_code: "+255",

    iso_code: "TZ",
  },
  {
    name: "Thailand",

    dial_code: "+66",

    iso_code: "TH",
  },
  {
    name: "Timor-Leste",

    dial_code: "+670",

    iso_code: "TL",
  },
  {
    name: "Togo",

    dial_code: "+228",

    iso_code: "TG",
  },
  {
    name: "Tokelau",

    dial_code: "+690",

    iso_code: "TK",
  },
  {
    name: "Tonga",

    dial_code: "+676",

    iso_code: "TO",
  },
  {
    name: "Trinidad and Tobago",

    dial_code: "+1 868",

    iso_code: "TT",
  },
  {
    name: "Tunisia",

    dial_code: "+216",

    iso_code: "TN",
  },
  {
    name: "Turkey",

    dial_code: "+90",

    iso_code: "TR",
  },
  {
    name: "Turkmenistan",

    dial_code: "+993",

    iso_code: "TM",
  },
  {
    name: "Turks and Caicos Islands",

    dial_code: "+1 649",

    iso_code: "TC",
  },
  {
    name: "Tuvalu",

    dial_code: "+688",

    iso_code: "TV",
  },
  {
    name: "Uganda",

    dial_code: "+256",

    iso_code: "UG",
  },
  {
    name: "Ukraine",

    dial_code: "+380",

    iso_code: "UA",
  },
  {
    name: "United Arab Emirates",

    dial_code: "+971",

    iso_code: "AE",
  },
  {
    name: "United Kingdom",

    dial_code: "+44",

    iso_code: "GB",
  },
  {
    name: "United States",

    dial_code: "+1",

    iso_code: "US",
  },
  {
    name: "Uruguay",

    dial_code: "+598",

    iso_code: "UY",
  },
  {
    name: "Uzbekistan",

    dial_code: "+998",

    iso_code: "UZ",
  },
  {
    name: "Vanuatu",

    dial_code: "+678",

    iso_code: "VU",
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",

    dial_code: "+58",

    iso_code: "VE",
  },
  {
    name: "Vietnam",

    dial_code: "+84",

    iso_code: "VN",
  },
  {
    name: "Virgin Islands, British",

    dial_code: "+1 284",

    iso_code: "VG",
  },
  {
    name: "Virgin Islands, U.S.",

    dial_code: "+1 340",

    iso_code: "VI",
  },
  {
    name: "Wallis and Futuna",

    dial_code: "+681",

    iso_code: "WF",
  },
  {
    name: "Yemen",

    dial_code: "+967",

    iso_code: "YE",
  },
  {
    name: "Zambia",

    dial_code: "+260",

    iso_code: "ZM",
  },
  {
    name: "Zimbabwe",

    dial_code: "+263",

    iso_code: "ZW",
  },
];
const appConstants = {
  defaults: {
    locale: "Singapore",
  },
  buttons: {
    submit: "Submit",
    cancel: "Cancel",
    back: "Back",
    close: "Close",
    next: "Next",
  },
  labels: {
    dob: "Date of birth",
    newPassword: "New password",
    userId: "Email Address (user ID)",
    password: "Password",
    idNumber: "ID number",
    idType: "ID Type",
    phoneNo: "Mobile Number",
    code: "Code",
    countryCode: "Country code",
    preferredName: "Preferred name",
    clientNumber: "Client number",
    MO: {
      userId: "Email",
    },
  },
  footerProp: {
    termConditionLabel: "Terms and Conditions",
    policiesNoticesLabel: "Other Policies and Notices",
    personalDataProtectionNoticeLabel: "Personal Data Protection Notice",
    PIDMTipsBrochureLabel: "PIDM's TIPS Brochure",
    aboutPIDMProtection: "A Member of PIDM | About PIDM’s Protection",
    customerServiceLabel: "Customer Service",
    copyRights:
      "Copyright© 2025 Great Eastern Holdings Limited (Reg No 1999 03008M). Great Eastern Holdings Ltd | Great Eastern Life Assurance Co Ltd | Great Eastern General Insurance Ltd",
  },
  signInProp: {
    heading: "Sign in with your user ID",
    emailAddressPlaceholder: "Enter your email address here",
    passwordPlaceholder: "Enter your password here",
    forgotPasswordLabel: "Forgot your password?",
    buttonLabel: "Next",
    dontHaveLabel: "Don't have an account?",
    signupLinkLabel: "Sign up",
    imageType: "protection",
    MO: {
      heading: "Sign in",
      emailAddressPlaceholder: "Email",
      resetPasswordLabel: "Reset your password",
      buttonLabel: "Continue",
      contactUsLabel: "Contact us",
      invalidCredentialHeading: "Invalid sign in credentials",
      invalidCredentialLabel: "Check that your email and password are entered correctly."
    },
  },
  contactUsProp: {
    heading: "Customer Service",
    subheading:
      "Monday to Friday, 9:00am to 5:30pm (closed on public holidays)",
    callLabel: "Call",
    emailLabel: "Email",
    callNumberSG: "+65 6248 2112",
    callNumberMY: "03-4813 3829",
    emailSG: "groupcso-sg@greateasternlife.com",
    emailMY: "grouplife@greateasternlife.com",
    label1: "For General Enquiries",
    label2: "DPS Enquiries",
    callNumber3: "6839 4565",
    email2: "dps-sg@greateasternlife.com",
  },
  refreshPageProp: {
    heading: "Session Timeout",
    subheading: "You will now be redirected to the login page.",
    imageType: "transaction-expired",
    popupTimer: parseInt(process.env.VUE_APP_REFRESH_TIMER), // 15mins (900 * 1000, but set to 300 * 1000 for testing purposes)
  },
  otpProps: {
    countdownValue: parseInt(process.env.VUE_APP_OTP_TIMER), // 1m 40s,
  },
  mobileOtpProp: {
    heading: "Enter your mobile OTP",
    subheading: "Enter your ..",
    sendAgain: "Send OTP again",
    validOtpLabel: (secs) => "Your OTP is valid for " + secs + " seconds",
    validMobileOtpLabel: "Your OTP is valid for 3 minutes.",
    validEmailOtpLabel: "Your OTP is valid for 10 minutes.",
    didNotOtpLabel: "I did not receive my OTP",
    differentNumberLabel: "I am using a different number",
    MO: {
      didNotOtpLabel: "Resend OTP",
    }
  },
  emailOtpProp: {
    heading: "Please verify your email",
    subheading: "Enter your ..",
    sendAgain: "Send OTP again",
    MO: {
      heading: "Enter email OTP",
    }
  },
  policyVerificationProp: {
    heading: "Verify you are a member",
    subheading:
      "Please verify that you are a policyholder via either Personal ID or Policy number.",
    imageType: "update-myinfo",
    idTypeLabel: "ID Type",
    idNumberLabel: "ID Number",
    dobLabel: "Date of birth",
    policyNumberLabel: "Policy Number",
    existingMemberIdHeading: "Existing Member ID account",
    existingMemberIdSubHeading: (email) =>
      "Based on what you have provided, it seems that your policies/certificates are currently associated with an existing Member ID: " +
      email,
    existingMemberIdOption1: "Log in and use existing Member ID",
    existingMemberIdOption2: "Use new email address",
    existingIdConfirmationHeading: "Before we continue",
    existingIdConfirmationSubHeading:
      "By selecting to use new email address, the existing Member ID account will be downgraded to become a basic account (Non-Policyholder)",
    stepName: "REG_VERIFY_CUSTOMER",
    termsOfUseLabel: "By continuing, I agree to the",
    termsOfUseLinkLabel: "Terms of Use and Privacy Policy.",
    idTypeExample: {
      sg: "NRIC, FIN, Passport or Birth Certificate.",
      my: "NRIC (e.g. 123456-78-9234) or Passport.",
    },
    noMatchHeading: "No records found",
    noMatchLabel: "Please check that your details are entered correctly. For further enquiries.",
    duplicateClientHeading: "You have an existing account",
    duplicateClientLabel: "Please sign in to your existing account. Need help?",
    contactUsLabel: "Contact us",
  },
  defaultPageProp: {
    heading: "Login Unsuccessful!",
    subheading: "Sorry, something went wrong. Close your Great Eastern Corporate app/browser tab and sign in again.",
    imageType: "no-available",
  },
  noPolicyProp: {
    heading: "Hang on, we are unable to find your Great Eastern policy",
    subheading:
      "Member ID is a service provided for Great Eastern policy holders only. <br/> <br/> If you are a policy holder experiencing issues, please try again later or get in touch with us.",
    imageType: "policy-no-fund",
  },
  noGidProp: {
    heading: "Hang on, we notice that you don’t have a Member ID account",
    subheading:
      "To fully utilise and access Great Eastern digital platforms, a Member ID account is required.",
    subheading1:
      "Set up a Member ID with a valid email address for added security when accessing our full suite of Great Eastern digital services. This is a <strong>one-time</strong> setup",
    imageType: "member-id",
  },
  newPasswordProp: {
    passwordExample: "Example: C@lvin123!",
  },
  createAccountProp: {
    heading: "Create your account",
    subheading:
      "Enter your details below. Your email address will be your user ID.",
    preferredNameLabel: "Preferred name",
    emailAddressLabel: "Email address (Member ID)",
    passswordLabel: "Password",
    tncLabel: "By Continuing, I agree to the",
    tncLinkLabel: "Terms of Use and Privacy Policy.",
    emailAddressPlaceholder: "Enter your email address here",
    passswordPlaceholder: "Enter your password here",
  },
  createAccountSuccessProp: {
    heading: "Success! Your account has been created",
    subheading:
      "You can now manage your policies online and enjoy exclusive perks on Great Eastern digital platforms!",
    imageType: "successful-fund-switch",
    buttonLabel: "Let's go",
  },
  changePasswordProp: {
    heading: "Change Password",
    subheading: "Create a new password to secure your account.",
    currentPwdLabel: "Current password",
    newPwdLabel: "New password",
  },
  changePasswordSuccessProp: {
    heading: "Password changed",
    imageType: "successful-fund-switch",
    subheading:
      "You have successfully changed your password.",
    buttonLabel: "Done",
  },

  resetPasswordSuccessProp: {
    heading: "Success! Your password has been reset",
    imageType: "successful-fund-switch",
    subheading: "You can now sign in to Great Eastern digital platforms using your new password.",
    buttonLabel: "Let's go!",
    MO: {
      heading: "Password reset",
      subheading: "You have successfully reset your password.",
      buttonLabel: "Sign in again",
    }
  },
  userProfileProp: {
    heading: "Profile",
    emailAddressLabel: "Email address",
    prefNameLabel: "Preferred name",
    phTypeLabel: "Policyholder type",
    deleteAccLabel: "Delete account",
    deviceInfo: "Show Device Info",
  },
  forgotPasswordProp: {
    heading: "Forgot your password?",
    subheading:
      "Enter your email address, and we'll send an OTP to your mobile number to reset your password.",
    emailAddressLabel: "Email address",
    resetPasswordHeading: "Enter your new password",
    placeholderText: "Enter your password",
    MO: {
      heading: "Reset your password",
      subheading:
        "Enter your sign-in email address below to receive your one-time password.",
      resetPasswordSubHeading: "Create a new password to secure your account.",
    },
  },
  deleteAccountProp: {
    heading: "Delete account",
    confirmationText: "Are you sure you want to delete your Member ID account?",
    imageType: "missing-info",
    subheading:
      "You will no longer have access to your account on Great Eastern digital platforms. Your account information will be permanently deleted.",
    feedbackHeading: "We're sad to see you go",
    feedbackSubheading: "Tell us why you're leaving:",
    feedbackConfirmationText:
      "Your feedback matters, is there anything else you'd like us to know?",
    feedbackLabel: "Enter your feedback here",
    goodByeHeading: "Good bye for now",
    goodByeSubheading:
      "Your Member ID account will be permanently deleted within the next five working days. If you change your mind, you can always sign-up for a new Member ID account again.",
    goodByeImageType: "sign-out",
  },
  deleteAccountFeedbackProp: {},
  updateRecordProp: {
    heading: "Please update your mobile number",
    errorHeading: "We're sorry.",
    subheading:
      "To help us identify you accurately, we recommend that you update your records with any of the method below.",
    option1: "Update via Myinfo ",
    option1Subheading: "(Have Singpass account)",
    option2: "Download personal particulars form",
    option2Subheading: "(Does not have Singpass account)",
    errorMessage:
      "The Singpass account used to retrieve Myinfo data is not the same as the policyholder. Please ensure the Singpass holder is the same person as the policyholder.",
  },
  recordDetailProp: {
    heading: "We have successfully retrieved your mobile number from Myinfo",
    nricLabel: "NRIC",
    mobileLabel: "Mobile number",
    buttonLabel: "Next",
  },
  personalParticularProp: {
    heading: "Change of personal particulars via form submission",
    subheading:
      "Please fill up the form and email it to us at wecare-sg@greateasternlife.com.",
    notifyMessage:
      "We will notify you via physical mail once your details are updated.",
  },
  registerMobileProp: {
    heading: "Register your mobile number",
    subheading:
      "Receive your one time password (OTP) on this mobile number next time you sign in next time.",
    linkLabel: "Update via Myinfo",
  },
  alertMessageProp: {
    errorBackgroundColor: "backgroundColor",
    errorIcon: "alert",
    errorIconColor: "primary",
    errorBorderColor: "backgroundColor",
    errorNonPolicyHolderStart:
      "Sorry, you do not have access to this application as you have not verified yourself as a Great Eastern customer. If you are a Great Eastern policyholder/certificate owner, please click ",
    errorNonPolicyHolderLinkLabel: "here",
    errorNonPolicyHolderEnd:
      " to verify yourself as a Great Eastern customer now.",
  },
  logoutProp: {
    heading: "Logout Success",
    imageType: "sign-out",
    subheading: "Thank you. \n You have logged out successfully.",
  },
  biometricSetting: {
    heading: "Biometric setting",
    subheading:
      "Manage your biometric registered with these device browsers.",
    subheading1:
      "If your biometric sign-in isn't working remove the device entry below and activate new one.",
    buttonLabel: "Activate biometric",
    buttonLabel2: "Back",
    dialogHeader: "Remove biometric",
    dialogBody: (device) =>
      `You are removing ${device}. Do you want to proceed?`,
  },
  messages: {
    ...messages,
  },
  countries: {
    ...countries,
  },
  urlContants: {
    loginUrl: "/login",
    registerUrl: "/register",
  },
};
let appProp = {};
appProp.install = function (Vue) {
  Vue.prototype.$getConstant = appConstants;
};
export default appProp;
